import { render, staticRenderFns } from "./WebAgentTab.vue?vue&type=template&id=474e4870&scoped=true"
import script from "./WebAgentTab.vue?vue&type=script&lang=js"
export * from "./WebAgentTab.vue?vue&type=script&lang=js"
import style0 from "./WebAgentTab.vue?vue&type=style&index=0&id=474e4870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e4870",
  null
  
)

export default component.exports